import { Box, Button, Typography, makeStyles } from "@material-ui/core";
import React from "react";

import { style } from "./style";

const useStyles = makeStyles(() => style);

/**
 * Terminal state for a carrier-route lookup that failed or ran out of time.
 *
 * Mirrors the flyering targeting maps' ErrorOverlay
 * (campaign-builder/channels/flyering/targeting/map/MapStates.tsx) which the
 * EDDM map never had — before this the same failure showed either a permanent
 * spinner or a silently empty map.
 */
/**
 * @param {object} props
 * @param {string} props.message
 * @param {string|null} [props.detail] reason-specific supporting line.
 * @param {() => void} [props.onRetry]
 */
export const MapErrorScreen = ({ message, detail = null, onRetry }) => {
  const classes = useStyles();

  return (
    <>
      <Box className={classes.background} />
      <Box className={classes.wrapper} data-cy="eddmMapLoadError">
        <Typography className={classes.title}>{message}</Typography>
        {/* `detail` is reason-specific (see ROUTE_LOAD_ERROR_DETAILS): a lookup the
            user cancelled themselves must not be told to check its connection. */}
        <Typography className={classes.description}>{detail || "Check your connection and try again."}</Typography>
        <Button
          className={classes.retryButton}
          variant="contained"
          color="primary"
          onClick={onRetry}
          data-cy="eddmMapRetryLoadAreasButton"
        >
          Retry
        </Button>
      </Box>
    </>
  );
};

export default MapErrorScreen;
